import { constants, mediaQueryStyles } from "@newsela/angelou";

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { sm } = breakpoints.BreakpointNames;

export const transcriptRootCss = {
  height: "50vh",
  maxWidth: "720px",
  width: "100%",

  // When transcripts get appended to the player on the smallest screen, remove the
  // height of the transcript container so there's not an empty white space below the mobile transcripts.
  [mediaQuery.upTo(sm)]: {
    height: 0,
  },
};
